module.exports = __webpack_public_path__ + "img/drive-vil-3.34d2d199.svg";